import PropTypes from 'prop-types';
// material
import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

Loader.propTypes = {
  align: PropTypes.string
};

export default function Loader({ align }) {
  return (
    <Box display="flex" justifyContent="center" alignItems={align} minHeight="100vh">
      <CircularProgress color="inherit" />
    </Box>
  );
}
